import * as CONST from "actions/action_constants";

export const dispatchUserPreferenceChange = (selector, name, value) => ({
  type: CONST.USER_PREFERENCE_CHANGE,
  selector,
  name,
  value
});
